import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Panel } from 'primereact/panel'

import {
  CustomDropdown,
  ImportExcelFile,
  Loading,
  PageHeader,
  TextBtn,
  ExcelModeloBuilder,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as ImportationHttp from '../../../../services/api/https/deliveries/importation.http'

function AssocAreaSeparacaoExcel({ history, dispatch }) {
  // Vars
  const tiposArquivos = [
    { label: 'ANTIGO - Modelo de Roteiro', value: 1 },
    { label: 'NOVO - Modelo de Roteiro', value: 2 },
    { label: 'BTV01 - Modelo', value: 3 },
    { label: 'CCSH01 - Modelo', value: 4 },
    { label: 'DAN01 - Assoc. de Areas em Lote', value: 5 },
    { label: 'VI01 - Assoc. Areas X Rotas', value: 6 },
    // Lactalis - Associação das área via N° Transporte priorizando a Primeira Entrega
    { label: 'LAC01 - Assoc. 1° Entrega - Transporte', value: 7 },
    { label: 'VI02 - Assoc. Areas X Placas', value: 8 },
  ]
  // Hooks
  const [isImporting, setIsImporting] = useState(false)
  const [tipoArquivoId, setTipoArquivoId] = useState('')

  // Events
  const onFileImported = async info => {
    try {
      setIsImporting(true)
      const {
        location: {
          state: { picking_id },
        },
      } = history
      await ImportationHttp.importAssocAreaExcel(picking_id, info, tipoArquivoId)
      dispatch(showMessageBox('Importação realizada com sucesso', null))
      history.goBack()
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsImporting(false)
    }
  }

  const onTipoArquivoChange = tipoArquivo_id => setTipoArquivoId(tipoArquivo_id)

  const onBtnVoltar = () => history.goBack()

  // Templates
  const getModeloExcel = () => {
    if (tipoArquivoId === 6) {
      // VI01 - Assoc. Areas X Veiculos
      return {
        colunas: [
          [
            'COL1',
            'COL2',
            'COL3',
            'COL4',
            'NUMERO_NF',
            'COL6',
            'COL7',
            'COL8',
            'COL9',
            'COL10',
            'COL11',
            'COL12',
            'ROTA_ENTREGA',
            'PLACA_VEICULO_ENTREGA',
          ],
        ],
        filename: 'VI01_Modelo_Assoc_Areas_Veiculos.xlsx',
      }
    }
    if (tipoArquivoId === 8) {
      // VI02 - Assoc. Areas X Veiculos
      return {
        colunas: [['ROMANEIO', 'NOTA', 'NOTA2', 'PLACA_FILHO']],
        filename: 'VI02_Modelo_Assoc_Areas_Veiculos.xlsx',
      }
    }
    return null
  }

  const modeloExcel = getModeloExcel()
  const mostrarBotaoBaixarModelo = tipoArquivoId === 6 || tipoArquivoId === 8

  // Render
  return (
    <div>
      <PageHeader>Associação Área - Importação Arquivo Excel</PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel header={<TextBtn onClick={onBtnVoltar}>Voltar</TextBtn>}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                value={tipoArquivoId}
                label="Selecione o Modelo para Importação"
                options={tiposArquivos}
                onChange={onTipoArquivoChange}
              />
            </div>
            <div className="p-col-4" style={{ paddingTop: 32 }}>
              {isImporting ? (
                <Loading size="xs" />
              ) : (
                <span>
                  <ImportExcelFile
                    label="Importar"
                    classes="btnImportar"
                    onFileImported={onFileImported}
                  />
                </span>
              )}
              {mostrarBotaoBaixarModelo && modeloExcel && (
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <ExcelModeloBuilder
                    modeloColunas={modeloExcel.colunas}
                    filename={modeloExcel.filename}
                  />
                </div>
              )}
            </div>
          </div>
        </Panel>
      </div>
    </div>
  )
}

export default connect()(withRouter(AssocAreaSeparacaoExcel))
